/**
 * Strips the `<measured-context>` tenant preamble the BFF injects into
 * the latest user message. The contract is server-side; this is the
 * defensive consumer cleanup so the block never appears in the chat UI.
 */
const TENANT_CONTEXT_BLOCK =
  /<measured-context\b[\s\S]*?<\/measured-context>\s*/gi;

/** Extract renderable text from any LangChain content shape. */
export function contentToText(content: unknown): string {
  let raw: string;
  if (typeof content === 'string') {
    raw = content;
  } else if (Array.isArray(content)) {
    raw = content
      .map((b) =>
        b &&
        typeof b === 'object' &&
        (b as Record<string, unknown>)['type'] === 'text' &&
        typeof (b as Record<string, unknown>)['text'] === 'string'
          ? ((b as Record<string, unknown>)['text'] as string)
          : ''
      )
      .join('');
  } else {
    raw = '';
  }
  return raw.replace(TENANT_CONTEXT_BLOCK, '').trimStart();
}
